/*
 * Sticky ATC mobile — hiện thanh mua dính đáy khi nút mua chính cuộn LÊN khỏi màn hình.
 * Đồng bộ giá hiển thị từ buy-box (đổi size → đổi giá). Chỉ tác động khi có .honest-pdp.
 */
(function () {
  var bar = document.querySelector('[data-pdp-sticky-atc]');
  if (!bar) return;

  var anchor =
    document.querySelector('.honest-pdp .product-form__buttons') ||
    document.querySelector('.honest-pdp product-form');
  var priceWrap = document.querySelector('.honest-pdp .price');
  var stickyPrice = bar.querySelector('[data-sticky-price]');

  function syncPrice() {
    if (!priceWrap || !stickyPrice) return;
    var p = priceWrap.querySelector(
      '.price-item--sale, .price-item--last, .price-item--regular'
    );
    if (p && p.textContent.trim()) stickyPrice.textContent = p.textContent.trim();
  }

  if (anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        // Hiện bar khi nút mua chính đã cuộn LÊN trên, khuất khỏi đỉnh màn hình
        bar.hidden = !(e.boundingClientRect.bottom < 0);
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  // Đồng bộ giá khi Dawn re-render buy-box lúc đổi biến thể
  if (priceWrap) {
    new MutationObserver(syncPrice).observe(priceWrap, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }
  document.addEventListener('change', syncPrice, true);
  syncPrice();
})();
